export default __webpack_public_path__ + "static/media/costumes_logo.49571ef7.png";